import { useEffect, useState, forwardRef } from 'react';
import FooterNav from '../../components/dashboard/FooterNav';
import Navbar from '../../components/dashboard/Navbar';
import Slider from '../../components/Slider';
import Main from '../../components/dashboard/Main';
import Products from '../../components/dashboard/Products';
import ReadyStockCheckingOut from '../../components/dashboard/ReadyStockCheckingOut';

import axios from  'axios';
import { Formik } from 'formik';

import jwtDecode from 'jwt-decode';
import { Link, useNavigate } from "react-router-dom";
import styledComponent from "styled-components";
import { styled } from '@mui/material/styles';

import {
  Autocomplete,
  Box,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  Typography,
  TextField,
  Button,
  Menu,
  MenuItem,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  LinearProgress,
  Modal,
  InputAdornment,
  InputLabel,
  IconButton,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  RadioGroup,
  Radio,
  SwipeableDrawer,
  Snackbar,
  Select,
  Stack,
  Paper,
  ListSubheader
} from "@mui/material";

import { blueGrey } from '@mui/material/colors';
import MuiAlert from '@mui/material/Alert';
import { tableCellClasses } from '@mui/material/TableCell';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';

import PhoneInput from 'react-phone-input-2';

import {
  Search,
  Notifications,
  ShoppingCart,
  Email,
  LocalAtm,
  ExitToApp,
  PowerOffRounded
} from "@material-ui/icons";

import SearchIcon from '@mui/icons-material/Search';
import mainLogo from '../../assets/logo.png';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import DeleteIcon from '@mui/icons-material/Delete';
import NavbarTransaksi from '../../components/dashboard/NavbarTransaksi';
import { TextareaAutosize } from '@material-ui/core';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '80%', md: 400 },
    maxHeight: '68vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    overflow: 'scroll'
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.common.black
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Container = styledComponent.div`
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
`;

const Wrapper = styledComponent.div`
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const verifyToken = (serviceToken) => {
  if (!serviceToken) {
      return false;
  }
  const decoded = jwtDecode(serviceToken);
  /**
   * Property 'exp' does not exist on type '<T = unknown>(token: string, options?: JwtDecodeOptions | undefined) => T'.
   */
  return decoded.exp > Date.now() / 1000;
};

const ReadyStockKirimComponent = ({ valueProvinceProp, provinces, cities, subdistricts, updatedCities, updatedSubsdistricts, beratPaket, profile }) => {
    const navigate = useNavigate();

    const [openAlert, setOpenAlert] = useState(false);
    const [alertStatus, setAlertStatus] = useState('success');
    const [alertMessage, setAlertMessage] = useState('');

    const handleClickAlert = () => {
      setOpenAlert(true);
    };

    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const [cartState, setCartState] = useState([]);
    const [jmlState, setJmlState] = useState(0);
    const [totalState, setTotalState] = useState(0);

    const [isCheckedOut, setCheckedOut] = useState(false);
    const [token, setToken] = useState(
      JSON.parse(localStorage.getItem('token')) !== null ? 
          JSON.parse(localStorage.getItem('token')).token :
          null
    );

    const [isDropship, setIsDropship] = useState(null);
    const [penerima, setPenerima] = useState(null);
    const [pengirim, setPengirim] = useState(null);
    const [telPengirim, setTelPengirim] = useState(null);
    const [telPenerima, setTelPenerima] = useState(null);
    const [isLoading, setLoading] = useState(true);
    const [selectedCourier, setCourier] = useState(null);

    const changePenerima = (e) =>  {
      setPenerima(e.target.value);
    };

    const changePengirim = (e) =>  {
      setPengirim(e.target.value);
    };

    const changeTelPengirim = (value) =>  {
      setTelPengirim(value);
    };

    const changeTelPenerima = (value) =>  {
      setTelPenerima(value);
    };

    const [valueAlamat, setValueAlamat] = useState(null);
    const [valueKodePos, setValueKodePos] = useState(null);

    const handleChangeAlamat = (e) => setValueAlamat(e.target.value);
    const handleChangePos = (e) => setValueKodePos(e.target.value);

    const [valueSubdistrict, setValueSubdistrict] = useState(null);
    const [inputSdValue, setInputSdValue] = useState(null);
    const handleSelectSubdistrict = (e, val) => {
        setValueSubdistrict(val);
        setInputSdValue(val.subdistrict_id);
        if(selectedCourier !== null) {
          handleCourirChange(selectedCourier);
        }
    };
    
    const [valueCity, setValueCity] = useState(null);
    const [inputCityValue, setInputCityValue] = useState(null);
    const handleSelectCity = async (e, val) => {
        setValueCity(val);
        setInputCityValue(val.city_id);
        try {
            const getData = await axios.get(`${process.env.REACT_APP_API_URL}/api/region/subdistrict/${val.city_id}`);
            updatedSubsdistricts(getData.data.result);
        } catch (err) {
            console.log(err);
        }
    };

    const [valueProvince, setValueProvince] = useState(null);
    const [inputProvValue, setInputProvValue] = useState(null);
    const handleSelectProvince = async (e, val) => {
        setValueProvince(val);
        setInputProvValue(val.province_id);
        try {
            const getData = await axios.get(`${process.env.REACT_APP_API_URL}/api/region/city/${val.province_id}`);
            updatedCities(getData.data.result);
        } catch (err) {
            console.log(err);
        }
    };

    const [shippingCost, setShippingCost] = useState({});
    const [shippingLoading, setShippingLoading] = useState(false);

    const handleCourirChange = async (courierValue) => {
      const courierCode = courierValue.split('|');
      if( courierCode[0] === 'OR' ) {
        try {
          const getShipping = await axios.post(`${process.env.REACT_APP_API_URL}/api/dashboard/shipping/cost`,
            {
              origin: 23,
              destination: inputSdValue,
              weight: beratPaket,
              courier: courierCode[1]
            },
            {
              headers: {
                Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
              }
            }
          );
          setShippingCost(getShipping.data.result.rajaongkir.results[0]);
          setShippingLoading(false);
  
        } catch (err) {
          console.log(err)
        }
      } else {
        setShippingLoading(false);
        setShippingCost({});
      }
    };

    const [layananState, setLayanan] = useState(null);

    const handleChangeDropship = async (value) => {
      if (value === 'tidak') {

        setValueAlamat(profile.alamat);
        setValueKodePos(profile.kodepos);
        
        const getProvinces = await axios.get(`${process.env.REACT_APP_API_URL}/api/region/province`);
        const filteredProvinces = getProvinces.data.result.filter((v) => v.province_id === parseInt(profile.provinsi));
        
        setValueProvince(filteredProvinces[0]);
        setInputProvValue(filteredProvinces[0].province_id);
        
        const getCities = await axios.get(`${process.env.REACT_APP_API_URL}/api/region/city/${filteredProvinces[0].province_id}`);
        const filteredCities = getCities.data.result.filter((v) => v.city_id === parseInt(profile.kota));

        updatedCities(getCities.data.result);
        setValueCity(filteredCities[0]);
        setInputCityValue(filteredCities[0].city_id);

        const getSubdistritct = await axios.get(`${process.env.REACT_APP_API_URL}/api/region/subdistrict/${filteredCities[0].city_id}`);
        const filteredSubdistricts = getSubdistritct.data.result.filter((v) => v.subdistrict_id === parseInt(profile.kecamatan));

        updatedSubsdistricts(getSubdistritct.data.result);
        setValueSubdistrict(filteredSubdistricts[0]);
        setInputSdValue(filteredSubdistricts[0].subdistrict_id);
      }
    };

    return (
        <div>
            <Grid container spacing={2}>
                <Snackbar
                  open={openAlert}
                  autoHideDuration={2500}
                  onClose={handleCloseAlert}
                  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                  key={'top' + 'center'}
                >
                    <Alert onClose={handleCloseAlert} severity={alertStatus} sx={{ width: '100%' }}>
                        {alertMessage}
                    </Alert>
                </Snackbar>
                <Grid item xs={12} my={2}>
                    <Typography variant="h5" fontWeight="700">Form Pengiriman</Typography>
                </Grid>
                <Grid item xs={12} my={2}>
                  <Formik
                    enableReinitialize
                    initialValues={{
                      dropship: null,
                      pengirim,
                      penerima,
                      provinsi: null,
                      kota: null,
                      kecamatan: null,
                      telPengirim: telPengirim,
                      telPenerima: telPenerima,
                      kurir: null,
                    }}
                    validate={values => {
                        const errors = {};
                        if (telPengirim === null || telPengirim === '62') {
                          errors.telPengirim = 'Wajib diisi';
                        }
                        if (telPenerima === null || telPenerima === '62') {
                          errors.telPenerima = 'Wajib diisi';
                        }
                        if (Object.keys(errors).length > 0) {
                          window.scrollTo(0, 0);  
                        }
                        return errors;
                    }}
                    onSubmit={async (values, { setSubmitting }) => {
                        values.dropship = isDropship;
                        values.telPengirim = telPengirim;
                        values.telPenerima = telPenerima;
                        values.alamat = valueAlamat;
                        values.kodepos = valueKodePos;
                        values.provinsi = inputProvValue;
                        values.kota = inputCityValue;
                        values.kecamatan = inputSdValue;
                        values.berat = beratPaket;
                        values.invoice = localStorage.getItem('invoicePengiriman');
                        values.kurir = selectedCourier;
                        values.layanan = layananState !== null ? layananState.split('|')[0] : null;
                        values.ongkir = layananState !== null ? layananState.split('|')[1] : null;

                        try {
                          await axios.post(`${process.env.REACT_APP_API_URL}/api/dashboard/shipping/send`,
                            values,
                            {
                              headers: {
                                Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                              }
                            }
                          );
                          const invoice = localStorage.getItem('invoicePengiriman');
                          setOpenAlert(true);
                          setAlertStatus('success');
                          setAlertMessage('Submit pengiriman berhasil');
                          navigate(`/dashboard/readystock/detailorder?invoice=${invoice}`);
                          localStorage.removeItem('invoicePengiriman');

                        } catch (err) {
                          
                          console.log(err)
                          setSubmitting(false);

                        }

                    }}
                  >
                    {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    /* and other goodies */
                    }) => (
                    <form onSubmit={handleSubmit}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <FormControl>
                            <RadioGroup
                              row
                              aria-labelledby="demo-controlled-radio-buttons-group"
                              name="dropship"
                              value={isDropship}
                              onChange={(event) => {
                                setIsDropship(event.target.value);
                                handleChangeDropship(event.target.value);
                              }}
                            >
                              <FormControlLabel value="ya" control={<Radio required/>} label="Dropship" />
                              <FormControlLabel value="tidak" control={<Radio required/>} label="Alamat Pribadi" />
                            </RadioGroup>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '16px', fontWeight: 700 }}>
                                Pengirim
                            </InputLabel>
                            <TextField
                                id="outlined-multiline-flexible"
                                size="small"
                                required
                                fullWidth
                                label="Nama Pengirim"
                                onChange={changePengirim}
                                name="pengirim"
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                Telepon Pengirim
                            </InputLabel>
                            <PhoneInput
                                disableDropdown
                                countryCodeEditable={false}
                                name="telPengirim"
                                country={'id'}
                                onlyCountries={['id']}
                                inputStyle={{ width: '100%', height: '3em' }}
                                value={telPengirim}
                                onChange={changeTelPengirim}
                            />
                            <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                {errors.telPengirim && touched.telPengirim && errors.telPengirim}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '16px', fontWeight: 700 }}>
                                Penerima
                            </InputLabel>
                            <TextField
                                id="outlined-multiline-flexible"
                                size="small"
                                required
                                fullWidth
                                label="Nama Penerima"
                                onChange={changePenerima}
                                name="penerima"
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                Telepon Penerima
                            </InputLabel>
                            <PhoneInput
                                required
                                disableDropdown
                                countryCodeEditable={false}
                                name="telPenerima"
                                country={'id'}
                                onlyCountries={['id']}
                                inputStyle={{ width: '100%', height: '3em' }}
                                value={telPenerima}
                                onChange={changeTelPenerima}
                            />
                            <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                {errors.telPenerima && touched.telPenerima && errors.telPenerima}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                Alamat Penerima *
                            </InputLabel>
                            <TextField
                                id="outlined-multiline-flexible"
                                required
                                fullWidth
                                multiline
                                rows={3}
                                value={valueAlamat}
                                onChange={handleChangeAlamat}
                                name="alamat"
                            />
                            <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                {errors.alamat && touched.alamat && errors.alamat}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                Kode Pos *
                            </InputLabel>
                            <TextField
                                id="outlined-multiline-flexible"
                                size="small"
                                required
                                fullWidth
                                value={valueKodePos}
                                onChange={handleChangePos}
                                inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', type: 'number' }}
                                name="kodepos"
                            />
                            <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                {errors.kodepos && touched.kodepos && errors.kodepos}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                Provinsi Tujuan
                            </InputLabel>
                            <Autocomplete
                                // disabled
                                fullWidth
                                size="small"
                                value={valueProvince}
                                onChange={handleSelectProvince}
                                options={provinces}
                                getOptionLabel={(option) => option.province_name}
                                renderOption={(props, option) => (
                                    <li {...props}>
                                        {option.province_name}
                                    </li>
                                )}
                                renderInput={(params) => <TextField {...params} required />}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>                            
                            <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                Kota/Kabupaten Tujuan
                            </InputLabel>
                            <Autocomplete
                                fullWidth
                                size="small"
                                value={valueCity}
                                onChange={handleSelectCity}
                                options={cities}
                                getOptionLabel={(option) => option.city_name}
                                renderOption={(props, option) => (
                                    <li {...props}>
                                        {option.city_name}
                                    </li>
                                )}
                                renderInput={(params) => <TextField {...params} required />}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                Kecamatan Tujuan
                            </InputLabel>
                            <Autocomplete
                                fullWidth
                                size="small"
                                value={valueSubdistrict}
                                onChange={handleSelectSubdistrict}
                                options={subdistricts}
                                getOptionLabel={(option) => option.subdistrict_name}
                                renderOption={(props, option) => (
                                    <li {...props}>
                                        {option.subdistrict_name}
                                    </li>
                                )}
                                renderInput={(params) => <TextField {...params} required />}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                              Berat (Gram)
                            </InputLabel>
                            <TextField
                                id="outlined-multiline-flexible"
                                disabled
                                size="small"
                                required
                                fullWidth
                                onChange={handleChange}
                                inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', type: 'number' }}
                                name="berat"
                                value={beratPaket}
                            />
                        </Grid>
                        {inputProvValue !== null && inputCityValue !== null && inputSdValue !== null && (
                          <Grid item xs={12}>
                            <FormControl sx={{ width: '100%' }}>
                              <InputLabel
                                id="demo-simple-select-helper-label"
                                sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                Kurir
                              </InputLabel>
                              <Select
                                fullWidth
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                name="kurir"
                                label="Kurir"
                                onChange={(event) => {
                                  setCourier(event.target.value);
                                  setShippingLoading(true);
                                  handleCourirChange(event.target.value);
                                }}
                                required
                              >
                                <MenuItem value="OR|jne">JNE</MenuItem>
                                <MenuItem value="OR|tiki">TIKI</MenuItem>
                                <MenuItem value="OR|pos">POS INDONESIA</MenuItem>
                                <MenuItem value="OR|wahana">WAHANA</MenuItem>
                                <MenuItem value="OR|sicepat">SICEPAT</MenuItem>
                                <MenuItem value='OR|jnt'>J&T</MenuItem>
                                <MenuItem value='OR|lion'>LION</MenuItem>
                                <MenuItem value='OR|anteraja'>Anteraja</MenuItem>
                                <MenuItem value='OR|ide'>ID Express</MenuItem>
                                {/* <optgroup label="Lainnya (Ongkir Manual)"> */}
                                <ListSubheader><b>Kurir lainnya (ongkir manual)</b></ListSubheader>
                                <MenuItem value='OM|idetruck'>&nbsp;&nbsp;ID Express Truck</MenuItem>
                                <MenuItem value='OM|jntcargo'>&nbsp;&nbsp;J&T Cargo</MenuItem>
                                <MenuItem value='OM|jtr'>&nbsp;&nbsp;JTR</MenuItem>
                                <MenuItem value='OM|Ahsan'>&nbsp;&nbsp;Ahsan</MenuItem>
                                <MenuItem value='OM|Baraka'>&nbsp;&nbsp;Baraka</MenuItem>
                                <MenuItem value='OM|Dakota'>&nbsp;&nbsp;Dakota</MenuItem>
                                <MenuItem value='OM|IndahCargo'>&nbsp;&nbsp;IndahCargo</MenuItem>
                                <MenuItem value='OM|Adam Cargo'>&nbsp;&nbsp;Adam Cargo</MenuItem>
                                <MenuItem value='OM|Pegasus'>&nbsp;&nbsp;Pegasus</MenuItem>
                                <MenuItem value='OM|Gosend'>&nbsp;&nbsp;GoSend</MenuItem>
                                <MenuItem value='OM|KALOG'>&nbsp;&nbsp;KALOG</MenuItem>
                                <MenuItem value='OM|Sentral'>&nbsp;&nbsp;Sentral</MenuItem>
                                <MenuItem value='OM|CMC KARGO'>&nbsp;&nbsp;CMC CARGO</MenuItem>
                                <MenuItem value='OM|Triplogic'>&nbsp;&nbsp;Triplogic</MenuItem>
                                <MenuItem value='OM|Ambil ke Pusat'>&nbsp;&nbsp;Ambil Ke Pusat</MenuItem>
                                <MenuItem value='OM|Disatukan'>&nbsp;&nbsp;Disatukan Paket Lainnya</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                        )}
                        {shippingLoading && (
                          <Grid item xs={12} align="center">
                            <Typography variant="body2">Loading ongkir ...</Typography>
                            <LinearProgress />
                          </Grid>
                        )}
                        {shippingCost && Object.keys(shippingCost).length > 0 && (
                          <Grid item xs={12}>
                            <FormControl sx={{ width: '100%' }}>
                              <InputLabel
                                id="demo-simple-select-helper-label"
                                sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                Layanan / Ongkir per KG
                              </InputLabel>
                              <Select
                                fullWidth
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                name="layanan"
                                label="Layanan / ongkir per KG"
                                onChange={(event) => setLayanan(event.target.value)}
                                required
                              >
                                {/* <MenuItem value="tes">tes</MenuItem> */}
                                {shippingCost.costs.map((item) => (
                                  <MenuItem value={`${item.service}|${item.cost[0].value}`}>{`${item.service} | ${item.cost[0].value}`}</MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>
                        )}
                        {/* missing code */}
                        <Grid item xs={12} sx={{ textAlign: 'right', padding: '10px 0px' }}>
                          <Button variant="contained" type="submit" disabled={isSubmitting || shippingLoading}>Kirim</Button>
                        </Grid>
                      </Grid>
                    </form>
                  )}
                  </Formik>                  
                </Grid>  
            </Grid>
        </div>
    )
}

export default ReadyStockKirimComponent
